<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    content-class="binding-sample-full-screen-dialog"
  >
    <v-toolbar fixed height="56px" class="toolbar">
      <v-toolbar-items class="toolbar-side-icon">
        <v-btn flat icon color="#545454" @click.native="onBack">
          <v-icon>
            arrow_back_ios
          </v-icon>
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-title
        class="text-xs-center ml-0 toolbar-title"
        style="flex-grow: 1;"
      >
        製本サンプル
      </v-toolbar-title>

      <v-toolbar-items class="toolbar-side-icon">
        <v-btn flat icon color="primary" @click.native="onClose">
          <img src="../../assets/images/close_icon.svg" alt="close" />
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <SampleBindingPage :page-top-id="pageTopId" />
  </v-dialog>
</template>

<script>
import SampleBindingPage from "./BindingSamplePage.vue";

export default {
  components: {
    SampleBindingPage
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageTopId() {
      return "binding-sample-page-top";
    }
  },
  methods: {
    onBack() {
      this.goToTop(); // 再度ダイアログを開いた時、先頭から開始するようにする。
      this.$emit("back");
    },
    onClose() {
      this.goToTop(); // 再度ダイアログを開いた時、先頭から開始するようにする。
      this.$emit("close-dialog");
    },
    goToTop() {
      const elem = document.getElementById(this.pageTopId);
      if (elem) {
        elem.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }
  }
};
</script>

<style>
.binding-sample-full-screen-dialog {
  scroll-padding-top: 72px; /* toolbarの高さを考慮して、スクロールの余白を追加 */
  overscroll-behavior: none;
}
</style>

<style scoped>
.toolbar {
  background-color: #ffffff;
  border-color: #0000001f;
  border-style: solid;
  border-width: 0 0 1px 0;
  box-shadow: none;
}
.toolbar-side-icon {
  width: 48px;
}
.toolbar-title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
}
</style>
